import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { ContentProvider } from "./contexts/ContentContext";

import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

import Home from "./pages/Home";
import Marketplace from "./pages/Marketplace";
import ReptileDetail from "./pages/ReptileDetail";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import BreedersList from "./pages/BreedersList";
import BreederProfile from "./pages/BreederProfile";
import Cart from "./pages/Cart";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Wishlist from "./pages/Wishlist";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";

const Layout = ({ children }) => {
  const location = useLocation();
  // Auth callback should render without header/footer
  if (location.pathname === "/auth/callback") {
    return <>{children}</>;
  }
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

const AppRouter = () => {
  const location = useLocation();
  // Handle hash-based session_id (from emergent auth) synchronously
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/reptile/:id" element={<ReptileDetail />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/breeders" element={<BreedersList />} />
        <Route path="/breeder/:slug" element={<BreederProfile />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ContentProvider>
          <AuthProvider>
            <CartProvider>
              <BrowserRouter>
                <AppRouter />
                <Toaster theme="dark" position="bottom-right" toastOptions={{
                  style: { background: "#0A0B0A", color: "#fff", border: "1px solid rgba(212,175,55,0.3)" }
                }} />
              </BrowserRouter>
            </CartProvider>
          </AuthProvider>
        </ContentProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
